<template>
      <crud-delete :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @delete="remove"
                 @close="$emit('close')"
                 fullscreen
    >

        <v-card-text>
            <v-row justify="center">
                <span class="title">{{areYouSure}}</span>
            </v-row>
        </v-card-text>
        <v-card-text>
            <surveys-form ref="form" :value="form" readonly/>
        </v-card-text>

    </crud-delete>
</template>

<script>
    //Provider  
    import SurveysProvider from "../../../../providers/SurveysProvider";
    
    //Forms
    import SurveysForm from "../../../../forms/SurveysForm/SurveysForm.vue";
    
    //Common
    import {CrudDelete, ClientError} from '@dracul/common-frontend'
    
    export default {
        name: "SurveysDelete",
        
        components: {CrudDelete, SurveysForm},
        
        props: {
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },
        
        data() {
            return {
                modal: false,
                title: 'delivery.surveys.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
                form: {
                    name: '',
                    description: '',
                    questions: []
                }
            }
        },
        mounted() {
            this.form = {
                name: this.item.name,
                description: this.item.description,
                questions: this.item.questions.map(q => ({
                    question: q.question,
                    isFreeResponse: q.isFreeResponse,
                    options: q.options,
                    isOpen: true
                }))
            }
        },
        methods: {
            remove() {
                this.loading = true
                SurveysProvider.deleteSurvey(this.item.id).then(result => {
                            if (result.data.deleteSurvey.success) {
                                this.$emit('itemDeleted',result.data.deleteSurvey)
                                this.$emit('close')
                            }else{
                                this.errorMessage = 'Error on Delete'
                            }
                        }
                    ).catch(error =>{
                        let clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                }).finally(() => this.loading = false)
            },
        },
    }
</script>


